import _styled from '@emotion/styled/base';
import { useTheme } from '@emotion/react';
import { forwardRef } from 'react';
import { Spacing } from '../../primitives/spacing.js';
import { SectionMessageFormErrors } from '../../SectionMessage/SectionMessageFormErrors/index.js';
import { Text } from '../../Text/index.js';
import { useFormErrors } from '../shared/hooks/use-form-errors.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { mediaQuery } from '../../primitives/media-queries.js';
import { shorthandSpacingCss } from '../../primitives/Spacer/index.js';
import { getColor } from '../../utils/themeUtils.js';
import { Colors } from '../../primitives/color.js';

const StyledForm = _styled("form", {
  target: "e13lgymu1"
})("margin-bottom:0;", shorthandSpacingCss, ";>*+*{:not([data-footer='true']){margin-top:", Spacing.scale[3], ";}}");
const DEFAULT_COLUMN_VALUE = '1fr 1fr';
const FormRow = _styled("div", {
  target: "e13lgymu0"
})("column-gap:", Spacing.scale[2], ";display:grid;grid-template-columns:", ({
  columnValues
}) => columnValues, ";max-width:448px;", ({
  mobileTemplateColumns
}) => Boolean(mobileTemplateColumns) && `
    @media ${mediaQuery.mobileXsDown} {
      grid-template-columns: ${mobileTemplateColumns};
      row-gap: ${Spacing.scale[3]};
    }
  `, ";");
FormRow.defaultProps = {
  columnValues: DEFAULT_COLUMN_VALUE
};
const FormInner = ({
  children,
  errors,
  heading,
  subheading,
  onSubmit,
  ...props
}, ref) => {
  const [hasErrors, formErrors] = useFormErrors(errors);
  const theme = useTheme();
  return jsxs(StyledForm, {
    onSubmit: onSubmit,
    ref: ref,
    ...props,
    children: [Boolean(heading || subheading) && jsxs("header", {
      children: [Boolean(heading) && jsx(Text.Heading, {
        mb: 1,
        size: "lg",
        children: heading
      }), Boolean(subheading) && jsx(Text.Body, {
        color: getColor(Colors.gray[600], Colors.gray[400])({
          theme
        }),
        size: "sm",
        children: subheading
      })]
    }), hasErrors && jsx(SectionMessageFormErrors, {
      formErrorLinks: formErrors
    }), children]
  });
};
const Form = forwardRef(FormInner);

export { Form, FormRow, StyledForm };
